import { CATEGORIES } from './constants';

export const isTruthyOrZero = (value) => value || value === 0;

export const getCategoryFieldsMap = (headerFields) => {
  if (!Array.isArray(headerFields)) return {};

  return headerFields.reduce((acc, field) => {
    if (field.fieldName.startsWith(`${CATEGORIES.PREFIX_KEY}.`)) {
      acc[field.fieldName] = field;
    }
    return acc;
  }, {});
};
